import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { WifiOff } from "lucide-react";

/**
 * OfflineBanner
 * Franja fija arriba de todo mientras el navegador reporta que no hay
 * conexión (eventos online/offline de window). No existía ningún aviso de
 * este tipo -- las peticiones simplemente fallaban en silencio.
 */
export default function OfflineBanner() {
  const { t } = useTranslation();
  const [online, setOnline] = useState(
    () => typeof navigator === "undefined" || navigator.onLine
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[80] bg-stone-900 text-white text-xs sm:text-sm font-semibold flex items-center justify-center gap-2 py-2 px-3"
      style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 0.5rem)" }}
      data-testid="offline-banner"
    >
      <WifiOff className="w-4 h-4 flex-shrink-0" />
      <span>{t("offline.banner")}</span>
    </div>
  );
}
